import baseAPI from './axiosApi'

const api={
    page:'/api-ir/staff/assessment/page',
    info:'/api-ir/staff/assessment/get/',
    add:'/api-ir/staff/assessment/add',
    edit:'/api-ir/staff/assessment/edit',
    del:'/api-ir/staff/assessment/delete/',
    commit:'/api-ir/staff/assessment/submit/',
    approve:'/api-ir/staff/assessment/approve',
    years:'/api-ir/staff/assessment/years',
    checkYear:'/api-ir/staff/assessment/checkYear'
}
export function list (data) {
    return baseAPI.axiosData(api.page,'get',data)
}
export function info (data) {
    return baseAPI.axiosData(api.info+data,'get')
}
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
export function edit (data) {
    return baseAPI.axiosData(api.edit,'put',data)
}
export function del (data) {
    return baseAPI.axiosData(api.del+data,'delete')
}
export function commit (data) {
    return baseAPI.axiosData(api.commit+data,'post')
}
export function approve (data) {
    return baseAPI.axiosData(api.approve,'post',data)
}
export function getYears () {
    return baseAPI.axiosData(api.years,'get')
}
export function checkYear (data) {
    return baseAPI.axiosData(api.checkYear,'get',data)
}
